import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone, identityProvider, nextIdentityProvider }) =>
    present(
      repository
        .updateIdentityProvider(
          planzone,
          identityProvider,
          nextIdentityProvider,
        )
        .then((updatedIdentityProvider) => ({
          planzone,
          identityProvider: updatedIdentityProvider,
        }))
        .catch(() =>
          Promise.reject({ planzone, identityProvider, nextIdentityProvider }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
